export const STORAGE_KEYS = {
  dashboard: {
    watchList: `dashboard-watch-list-${process.env.NEXT_PUBLIC_ENV}`,
    config: `dashboard-config-${process.env.NEXT_PUBLIC_ENV}`,
    exchange: `dashboard-exchange-${process.env.NEXT_PUBLIC_ENV}`,
    layouts: `dashboard-layouts-v2-${process.env.NEXT_PUBLIC_ENV}`,
    // v2: groups became account-agnostic (members, not symbols) — v1 entries have no `members`.
    positionGroups: `dashboard-position-groups-v2-${process.env.NEXT_PUBLIC_ENV}`,
    aggregatePositions: `dashboard-aggregate-positions-${process.env.NEXT_PUBLIC_ENV}`,
    linkingGroups: `dashboard-linking-groups-${process.env.NEXT_PUBLIC_ENV}`,
    unlinkedCards: `dashboard-unlinked-cards-${process.env.NEXT_PUBLIC_ENV}`,
    chartOption: `dashboard-chart-option-${process.env.NEXT_PUBLIC_ENV}`,
    chartOptionChainVisiblePreference: `dashboard-chart-option-chain-visible-pref-${process.env.NEXT_PUBLIC_ENV}`,
    chartTabTimeframe: `dashboard-chart-tab-timeframe-${process.env.NEXT_PUBLIC_ENV}`,
    linkingColors: `dashboard-linking-colors-${process.env.NEXT_PUBLIC_ENV}`,
    linkingGroupNames: `dashboard-linking-group-names-${process.env.NEXT_PUBLIC_ENV}`,
    focusedPageId: `dashboard-focused-page-id-${process.env.NEXT_PUBLIC_ENV}`,
    orderFormPopup: `dashboard-order-form-popup-${process.env.NEXT_PUBLIC_ENV}`,
    orderFormPopupConfig: `dashboard-order-form-popup-config-${process.env.NEXT_PUBLIC_ENV}`,
    orderFormPopupExpanded: `dashboard-order-form-popup-expanded-${process.env.NEXT_PUBLIC_ENV}`,
    orderFormLastAccountByTradeVenue: `dashboard-order-form-last-account-by-trade-venue-${process.env.NEXT_PUBLIC_ENV}`,
    orderFormDefaultAccountByTradeVenue: `dashboard-order-form-default-account-by-trade-venue-${process.env.NEXT_PUBLIC_ENV}`,
    pageTabsOrder: `dashboard-page-tabs-order-${process.env.NEXT_PUBLIC_ENV}`,
    pageLastUsedAt: `dashboard-page-last-used-at-${process.env.NEXT_PUBLIC_ENV}`,
    pinnedPageIds: `dashboard-pinned-page-ids-${process.env.NEXT_PUBLIC_ENV}`,
    hiddenPageIds: `dashboard-hidden-page-ids-${process.env.NEXT_PUBLIC_ENV}`,
    pageAutoHideDays: `dashboard-page-auto-hide-days-${process.env.NEXT_PUBLIC_ENV}`,
    mobileCollapsed: `dashboard-mobile-collapsed-${process.env.NEXT_PUBLIC_ENV}`,
    recentWatchTickers: `dashboard-recent-watch-tickers-${process.env.NEXT_PUBLIC_ENV}`,
    recentCalendarAreas: `dashboard-recent-calendar-areas-${process.env.NEXT_PUBLIC_ENV}`,
    perceptFavoriteTimeframes: `dashboard-percept-favorite-timeframes-${process.env.NEXT_PUBLIC_ENV}`,
    recentOptionTickers: `dashboard-recent-option-tickers-${process.env.NEXT_PUBLIC_ENV}`,
    commandPaletteUsage: `dashboard-command-palette-usage-${process.env.NEXT_PUBLIC_ENV}`,
    commandPaletteLastUsed: `dashboard-command-palette-last-used-${process.env.NEXT_PUBLIC_ENV}`,
    uiStateCache: `dashboard-ui-state-cache-${process.env.NEXT_PUBLIC_ENV}`,
    homeLastVisit: `dashboard-home-last-visit-${process.env.NEXT_PUBLIC_ENV}`,
    homeAiBrief: `dashboard-home-ai-brief-${process.env.NEXT_PUBLIC_ENV}`,
    homeHiddenDatapoints: `dashboard-home-hidden-datapoints-${process.env.NEXT_PUBLIC_ENV}`,
    welcomeGuide: `dashboard-welcome-guide-${process.env.NEXT_PUBLIC_ENV}`,
    tutorialProgress: `dashboard-tutorial-progress-${process.env.NEXT_PUBLIC_ENV}`,
    // Locators of research runs still in flight (or not yet notified) — see research-active-jobs.ts.
    researchActiveJobs: `dashboard-research-active-jobs-${process.env.NEXT_PUBLIC_ENV}`,
  },
  // sessionStorage (tab-scoped) — see open-assistant.ts.
  assistant: {
    sessionStartedAt: `assistant-session-started-at-${process.env.NEXT_PUBLIC_ENV}`,
    newChatAt: `assistant-new-chat-at-${process.env.NEXT_PUBLIC_ENV}`,
  },
  notifications: {
    filters: `notification-filters-${process.env.NEXT_PUBLIC_ENV}`,
  },
  optionTable: {
    config: `option-table-config-${process.env.NEXT_PUBLIC_ENV}`,
  },
  rfq: {
    popupPosition: (cardId: string) =>
      `rfq-popup-position-${cardId}-${process.env.NEXT_PUBLIC_ENV}`,
  },
  riskSlides: {
    savedScenarios: `risk-slides-saved-scenarios-${process.env.NEXT_PUBLIC_ENV}`,
  },
  screener: {
    prefs: `screener-prefs-${process.env.NEXT_PUBLIC_ENV}`,
  },
  settings: {
    sound: `settings-sound-${process.env.NEXT_PUBLIC_ENV}`,
    hideBalances: `settings-hide-balances-${process.env.NEXT_PUBLIC_ENV}`,
    numberFormat: `settings-number-format-${process.env.NEXT_PUBLIC_ENV}`,
    layoutLocked: `settings-layout-locked-${process.env.NEXT_PUBLIC_ENV}`,
    chartEngine: `settings-chart-engine-${process.env.NEXT_PUBLIC_ENV}`,
    streamInterval: `settings-stream-interval-${process.env.NEXT_PUBLIC_ENV}`,
    papertradeOneSecondEntry: `settings-papertrade-one-second-entry-${process.env.NEXT_PUBLIC_ENV}`,
    arbAnalysisSections: `settings-arb-analysis-sections-${process.env.NEXT_PUBLIC_ENV}`,
  },
}
